package com.merkost.handpass.api.dto.admin

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class AuditEntry(
    val id: String,
    @SerialName("viewer_id") val viewerId: String?,
    @SerialName("viewer_name") val viewerName: String?,
    @SerialName("viewer_avatar_url") val viewerAvatarUrl: String?,
    @SerialName("target_type") val targetType: AdminTargetType,
    @SerialName("target_id") val targetId: String,
    @SerialName("viewed_at") val viewedAt: String,
)
